import Vue from 'vue'
import Router from 'vue-router'
const App = () => import('../App')
const home = () => import('../pages/home/home')
const login = () => import('../pages/login/login')
const collectList = () => import('../pages/collect/collectList')
const collect = () => import('../pages/collect/children/collect')
const shelfList = () => import('../pages/shelf/shelfList')
const shelf = () => import('../pages/shelf/children/shelf')
const pickingList = () => import('../pages/picking/pickingList')
const picking = () => import('../pages/picking/children/picking')
const pickingDetails = () => import('../pages/picking/children/children/pickingDetails')
const packingList = () => import('../pages/packing/packingList')
const packing = () => import('../pages/packing/children/packing')
const shipmentDetails = () => import('../pages/packing/children/shipmentDetails')
const ScanStorage = () => import('../pages/ScanStorage/ScanStorage')
const moveStock = () => import('../pages/moveStock/moveStock')
const boxMoveStock = () => import('../pages/moveStock/children/boxMoveStock')
const trayMoveStock = () => import('../pages/moveStock/children/trayMoveStock')
const scatteredMoveStock = () => import('../pages/moveStock/children/scatteredMoveStock')
const moveTraySku = () => import('../pages/moveTraySku/moveTraySku')
const createTag = () => import('../pages/createTag/createTag')
const createTagDetails = () => import('../pages/createTag/children/createTagDetails')
const Inventory = () => import('../pages/Inventory/Inventory')
const InventoryDetails = () => import('../pages/Inventory/children/InventoryDetails')
const taryDetails = () => import('../pages/Inventory/children/children/taryDetails')
const setting = () => import('../pages/setting/setting')
const searchStock = () => import('../pages/searchStock/searchStock')
const modifyTag = () => import('../pages/modifyTag/modifyTag')
const trayGather = () => import('../pages/trayGather/trayGather')
const supplierCollect = () => import('../pages/supplierCollect/supplierCollect')
const bluetPrint = () => import('../pages/bluetPrint/bluetPrint')
const revision = () => import('../pages/bluetPrint/revision')
const test = () => import('../pages/test/test')
const test2 = () => import('../pages/test/test2')
const b2bOrderList = () => import('../pages/b2bOrder/orderList')
const b2bOrderDetail = () => import('../pages/b2bOrder/orderDetail')
const stockAdjust = () => import('../pages/stockAdjust/stockAdjust')

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    component: App,
    children: [
      {
        path: '',
        redirect: '/login'
      },
      {
        path: '/login',
        name: 'login',
        component: login
      },
      {
        path: '/home',
        name: 'home',
        component: home
      },
      {
        path: '/b2bOrder',
        name: 'b2bOrderList',
        component: b2bOrderList
      },
      {
        path: '/b2bOrder/detail',
        name: 'b2bOrderDetail',
        component: b2bOrderDetail
      },
      {
        path: '/stockAdjust',
        name: 'stockAdjust',
        component: stockAdjust
      },
      {
        path: 'revision',
        name: 'revision',
        component: revision
      },
      {
        path: '/bluetPrint',
        name: 'bluetPrint',
        component: bluetPrint
      },
      {
        path: '/supplierCollect',
        name: 'supplierCollect',
        component: supplierCollect
      },
      {
        path: '/collectList',
        component: collectList,
        children: [
          {
            path: 'collect',
            component: collect,
            children: [{
              path: 'searchStock',
              component: searchStock
            }]
          }
        ]
      },
      {
        path: '/shelfList',
        component: shelfList,
        children: [
          {
            path: 'shelf',
            component: shelf,
            children: [{
              path: 'searchStock',
              component: searchStock
            }]
          }
        ]
      },
      {
        path: '/pickingList',
        name: 'pickingList',
        component: pickingList,
        children: [
          {
            path: 'picking',
            name: 'picking',
            component: picking,
            children: [{
              path: 'searchStock',
              component: searchStock
            }, {
              path: 'pickingDetails',
              component: pickingDetails
            }]
          }
        ]
      },
      {
        path: '/packingList',
        component: packingList,
        children: [
          {
            path: 'packing',
            component: packing,
            children: [{
              path: 'shipmentDetails',
              component: shipmentDetails
            }]
          }
        ]
      },
      {
        path: '/ScanStorage',
        component: ScanStorage
      },
      {
        path: '/createTag',
        component: createTag,
        children: [{
          path: 'createTagDetails',
          component: createTagDetails
        }]
      },
      {
        path: '/Inventory',
        component: Inventory,
        children: [{
          path: 'InventoryDetails',
          component: InventoryDetails,
          children: [{
            path: 'taryDetails',
            component: taryDetails
          }]
        }]
      },
      {
        path: '/moveStock',
        component: moveStock,
        children: [
          {
            path: 'boxMoveStock',
            component: boxMoveStock
          },
          {
            path: 'trayMoveStock',
            component: trayMoveStock
          },
          {
            path: 'scatteredMoveStock',
            component: scatteredMoveStock
          }
        ]
      },
      {
        path: '/moveTraySku',
        component: moveTraySku
      },
      {
        path: '/setting',
        component: setting
      },
      {
        path: '/searchStock',
        component: searchStock
      },
      {
        path: '/modifyTag',
        component: modifyTag
      },
      {
        path: '/test',
        component: test
      },
      {
        path: '/test2',
        component: test2
      },
      {
        path: 'trayGather',
        component: trayGather
      }
    ]
  }],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})




// WEBPACK FOOTER //
// ./src/router/index.js